import { put, call, select } from 'redux-saga/effects';
import { fetchUserSuccess, updateUserFailed, updateUserSuccess } from 'actions/user';
import api from '../utils/api';
import { getUser } from '../reducers/user';
import { showModal } from '../actions/modal';
import { receiveFetchAchievements } from '../actions/achievements';
import { fetchErrorHandler } from '../actions/fetchErrorHandler';

const URL = '/users';

export function* fetchUser() {
  try {
    const { id } = yield select(getUser);
    const { data: user } = yield call(api().get, `${URL}/${id || 'me'}`);
    // default settings for notifications
    const defaultSettings = {
      videoCaptions: true,
      reminder: false,
      muxPlayback: false,
    };

    const initUserWithSettings = {
      ...user,
      settings: {
        ...defaultSettings,
        ...user.settings,
      },
    };

    yield put(fetchUserSuccess(initUserWithSettings));
  } catch (error) {
    yield put(fetchErrorHandler(error.response, 'Something went wrong'));
  }
}

export function* updateUser(action) {
  try {
    const { data: user, modal } = action.payload;
    const { id } = yield select(getUser);

    let picture = null;

    // if image exists then update user picture
    if (user.file) {
      const { data } = yield call(api().post, '/file', user.file, {
        headers: {
          'content-type': 'multipart/form-data',
        },
      });

      picture = data.fileName;
    }

    delete user.file;

    const userDetails = picture ? { ...user, picture } : { ...user };

    const { data } = yield call(api().put, `${URL}/${id || 'me'}`, userDetails);
    yield put(updateUserSuccess(data));

    const { data: achievements } = yield call(api().get, `/users/achievements`);

    yield put(receiveFetchAchievements(achievements));
    if (modal) {
      yield put(showModal(modal.type, modal.data));
    }
  } catch (error) {
    yield put(fetchErrorHandler(error.response, 'Something went wrong'));
    // The api() response interceptor rejects with the response body, not the axios error, so the
    // API message sits at `error.message`. `statusCode` marks it as one of ours — a transport
    // failure rejects with a real Error whose message ("Network Error") is not for the user.
    const errorMessage =
      typeof error?.message === 'string' && error?.statusCode
        ? error.message
        : 'Something went wrong';
    // Keyed by flow so `getErrorMessage(state, 'update')` can surface it on the profile form.
    yield put(updateUserFailed({ error: { update: { errorMessage } } }));
  }
}
